import { fromJS } from 'immutable';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { FETCH_VISITORS } from '../constants/asyncActionTypes';
import { getVisitors } from '../clients/getVisitors';
export const fetchVisitors = createAsyncAction({
  requestFn: getVisitors,
  actionTypes: FETCH_VISITORS,
  toRecordFn: fromJS
});